import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";

import { getIn, useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../../add/form/types";
import { EditSolutionFormValues } from "../../../edit/form/types";

function AlertCheckBox() {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  const dataMissing =
    !context.values["risk-monitoring"]["geospatial-file"] &&
    !context.values["risk-monitoring"]["geospatial-id"];
  const currentAlertSet =
    context.values["risk-monitoring"]["is-risk-alert-enabled"];

  const path = "risk-monitoring.is-risk-alert-enabled";
  const error = getIn(context.errors, path) as string | undefined;
  const touched = Boolean(getIn(context.touched, path));
  const showError = touched && Boolean(error);

  return (
    <FormControl error={showError} sx={{ marginBottom: "2rem" }}>
      <FormControlLabel
        checked={currentAlertSet}
        disabled={dataMissing}
        control={
          <Checkbox
            id="is-risk-alert-enabled"
            name="risk-monitoring.is-risk-alert-enabled"
            data-testid="alert-enabled-checkbox"
            role="checkbox"
            checked={currentAlertSet}
            onChange={context.handleChange}
            slotProps={{ input: { "aria-label": "Enable Alerts" } }}
            disabled={dataMissing}
            onBlur={() => context.setFieldTouched(path, true, false)}
          />
        }
        label="Enable Alerts"
      />
      {showError ? <FormHelperText>{error}</FormHelperText> : null}
    </FormControl>
  );
}

export default AlertCheckBox;
